<template>
<div class="container" id="post_wrap">
	
	<div v-if="post_id > 0">
		<h4 class="gold">
			<small @click="goto_page('/forum/post/' + post_id)" class="gold pointer">
				Back to Post <i class="fas fa-chevron-left"></i>
			</small> Add Reply
		</h4>
		
		<b-card>
			<div class="row">
				<div class="col-md-12">
					<b-form @submit="postAdd">
						<b-form-group>
							<b-form-input
								id="title"
								v-model="reply.title"
								type="text"
								required
								placeholder="Enter Reply Header"
								maxlength="150"
							></b-form-input>
						</b-form-group>
						
						<b-form-group>
							<label><small class="gold">
							* To post a YouTube or Vimeo video, just paste the URL into the textarea below (each video link on a new line).
							</small></label>
							<b-form-textarea
								id="textarea"
								v-model="reply.main_text"
								placeholder="What have you got to say?"
								rows="20"
								max-rows="20"
							></b-form-textarea>
						</b-form-group>
						
						
						<h5 v-if="error_message != ''" v-text="error_message" class="text-danger"></h5>
						
						<b-button type="submit" variant="primary">
							<i class="far fa-hand-point-right"></i> Post Reply
						</b-button>
						
						<b-button type="button" variant="outline-secondary" @click="goto_page('/forum/post/' + post_id)">
							<i class="fas fa-times"></i> Cancel
						</b-button>
					</b-form>

				</div>
			</div>
		</b-card>

	</div>
	
	<div v-else>
		<div class="text-center gold my-2 p-2">
			<b-spinner class="align-middle"></b-spinner>
			<br />
			<strong>Loading...</strong>
		</div>
	</div>
	

  
	
</div>
</template>


<script>
import axios from "axios";

export default {
	name: "PostReply",
	props: {
	},
	data() {
		return {
			error_message: '',
			reply: {
				title: '',
				main_text: '',
			},
			session_id: this.$store.state.session_id,
			temp : null,
		}
	},
	computed:{
		post_id(){
			var post_id = 0;
			if(this.$route.params.post_id){
				post_id = this.$route.params.post_id;
			}
			return post_id;
		},
		post_type(){
			var post_type = null;
			if(this.$route.params.post_type){
				post_type = this.$route.params.post_type;
			}
			return post_type;
		},
		reply_id(){
			var reply_id = 0;
			if(this.$route.params.reply_id){
				reply_id = this.$route.params.reply_id;
			}
			return reply_id;
		},
	},
	methods:{
		
		goto_page(page){
			this.$router.push(page);
		},
		
		postAdd(e){
			let _this = this;
			e.preventDefault();
			
			console.log('postAdd');

			let params = new URLSearchParams();
			params.append('token', this.session_id);
			params.append('type', this.post_type);
			params.append('post_id', this.post_id);
			params.append('reply_id', this.reply_id);
			
			params.append('title', this.reply.title);
			params.append('main_text', this.reply.main_text);

			axios({
				method: 'post',
				url: _this.$store.state.api_url + "forum/replyAdd",
				data: params,

			}).then(function (response) {
				if(response.data.status == 1){
					_this.$router.push('/forum/post/' + _this.post_id);
				}
				else{
					_this.error_message = response.data.message;
				}
				
			}).catch(function (error) {
				console.log(error);
			});
		},

	},
	mounted() {
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
